// extracted by mini-css-extract-plugin
export default {"title_input":"formInput_title_input__SEB7W","error":"formInput_error__6vh0A"};